import { render, staticRenderFns } from "./IncomingCall.vue?vue&type=template&id=b477cdb4&scoped=true&"
import script from "./IncomingCall.vue?vue&type=script&lang=js&"
export * from "./IncomingCall.vue?vue&type=script&lang=js&"
import style0 from "./IncomingCall.vue?vue&type=style&index=0&id=b477cdb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b477cdb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
